<section class="page-user-profile users-view">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="user-profile-images">
          <!-- user timeline image -->
          <img
            src="../../../../../assets/img/banner/Profile Banner.png"
            class="img-fluid rounded-top user-timeline-image"
            alt="User Timeline Image"
          />
           <img
            *ngIf="studentData?.image"
            [src]="imageUrl+studentData?.image"
            class="user-profile-image rounded-circle object-fit-cover mr-1" 
            alt="User Profile Image"
            height="140"
            width="140"
          /> 
          <div
          *ngIf="!studentData?.image"
          [class.initial-alpha]="!studentData?.image"
          class="user-profile-image user-pro-name-word   "
        >
          <div >
            <p *ngIf="role =='student'">{{ studentData?.name | titlecase | shortName }}</p> 
            <p *ngIf="role !=='student'">{{user?.name | titlecase | shortName}}</p>
          </div>
        </div>
        </div>
        <div class="user-profile-text" *ngIf="role =='student'">
          <h4 class="profile-text-color mb-0">{{ studentData?.name |titlecase }}</h4>
          <small>{{ studentData?.roles }}</small>
        </div>
        <div class="user-profile-text" *ngIf="role !=='student'">
          <h4 class="profile-text-color mb-0">{{ user?.name |titlecase }}</h4>
          <small>{{ user?.roles }}</small>
        </div>
        <div class="card-content">
          <div class="card-body">
            <div *ngIf="role =='student'"
              class="user-profile-buttons d-flex justify-content-center justify-content-sm-start"
            >
              <a *ngIf="role ==='admin'"
                href="page-users-edit.html"
                class="btn bg-light-primary px-3 py-1"
                [routerLink]="['/student-edit', studentData?.id]"
                (click)="editStudent(studentData?.id)"
                >Edit</a
              >
              <a
            
              class="btn bg-light-primary px-3 py-1"
              (click)="changePassword(studentData?.id)"
              >Change Password</a
            >
            </div>
            <div *ngIf="role !=='student'"
            class="user-profile-buttons d-flex justify-content-center justify-content-sm-start"
          >
            <a *ngIf="role ==='admin'"
              href="page-users-edit.html"
              class="btn bg-light-primary mr-2 px-3 py-1"
              [routerLink]="['/student-edit', user?.id]"
              (click)="editStudent(user?.id)"
              >Edit</a
            >
            <a
          
            class="btn bg-light-primary mr-2 px-3 py-1"
            (click)="changePassword(user?.id)"
            >Change Password</a
          >
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
 <div class="row">
    <div class="col-12">
      <div class="row equal">
        <!-- About starts -->
    <!------ About For Admin ---------- -->
    <div class="col-12 col-xl-12"  *ngIf="role =='admin' || role == 'employee'">
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="card-title m-0">About</h4>
          <!-- <span class="cursor-pointer"
            ><i class="ft-more-vertical-"></i
          ></span> -->
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-borderless">
                <tbody>
                  <tr>
                    <td>Name:</td>
                    <td class="users-view-name"  *ngIf="role =='admin' || role == 'employee'">
                      <span>{{ user?.name | titlecase }}</span>
                      <span *ngIf="!user.name">Data Not Found</span>
                    </td>
                  </tr>
                  <tr>
                    <td>E-mail:</td>
                    <td class="users-view-name"  *ngIf="role =='admin' || role =='employee' ">
                      <span>{{ user?.email }}</span>
                      <span *ngIf="!user.email">Data Not Found</span>
                    </td>
                    
                  </tr>
                  <tr>
                    <td>Phone No:</td>
                    <td class="users-view-name"  *ngIf="role =='admin' || role =='employee'">
                      <span>{{ user?.phone }}</span>
                      <span *ngIf="!user.phone">Data Not Found</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!----------- End ------------------- -->
        <div class="col-12 col-xl-6"  *ngIf="role =='student'">
          <div class="card">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h4 class="card-title m-0">About</h4>
              <!-- <span class="cursor-pointer"
                ><i class="ft-more-vertical-"></i
              ></span> -->
            </div>
            <div class="card-content">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-borderless">
                    <tbody>
                      <tr>
                        <td>Name:</td>
                        <td class="users-view-name"  *ngIf="role =='student'">
                          <span>{{ studentData?.name | titlecase }}</span>
                          <span *ngIf="!studentData?.name">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>E-mail:</td>
                        <td  *ngIf="role =='student'">
                          <span>{{ studentData?.email}}</span>
                          <span *ngIf="!studentData?.email">Data Not Found</span>
                        </td>
                      </tr>
                      <tr>
                        <td>Phone No:</td>
                        <td  *ngIf="role =='student'">
                          <span>{{ studentData?.phone}}</span>
                          <span *ngIf="!studentData?.phone">Data Not Found</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- About ends -->
        <!-- Info starts -->
        <div class="col-12 col-xl-6"  *ngIf="role !=='admin' && role !=='employee'  && studentData?.team !=null ">
          <div class="card">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h4 class="card-title m-0">Team</h4>
              <!-- <span class="cursor-pointer"
                ><i class="ft-more-vertical-"></i
              ></span> -->
            </div>
            <div class="card-content">
              <div class="card-body">
                <table
                  class="table table-borderless">
                  <tbody>
                    <tr>
                      <td>Name:</td>
                      <td>
                        <span >{{ studentData?.team?.name}}</span>
                        <span *ngIf="!studentData?.team?.name">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Notes:</td>
                      <td>
                        <span>{{ studentData?.team?.notes}}</span>
                        <span *ngIf="!studentData?.team?.notes">Data Not Found</span>
                      </td>
                    </tr>
                   <tr>
                    <td>description:</td>
                    <td>
                      <span>{{ studentData?.team?.description}}</span>
                      <span *ngIf="!studentData?.team?.description">Data Not Found</span>
                    </td>
                   </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- Info ends -->
        <!-- Personal Info starts -->
        <div class="col-12 col-xl-6"  *ngIf="role !=='admin' && role !=='employee' && studentData?.college != null">
          <div class="card">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h4 class="card-title m-0">College</h4>
              <!-- <span class="cursor-pointer"
                ><i class="ft-more-vertical-"></i
              ></span> -->
            </div>
            <div class="card-content">
              <div class="card-body">
                <table class="table table-borderless">
                  <tbody>
                    <tr>
                      <td>College:</td>
                      <td>
                        <span>{{ studentData?.college?.name | titlecase}}</span>
                        <span *ngIf="!studentData?.college?.name">Data Not Found</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-12"  *ngIf="role !=='admin' && role !=='employee'">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <h4 class="card-title">
                  <span>Course</span>
                 </h4>
                 <div class="mt-3" *ngFor="let course of courses">
                  <tbody >
                  
                    <tr>
                      <td class="width_td_10rem">Course:</td>
                      <td>
                        <span style="font-size: bold;">{{course?.title}} <a href="{{courseUrl}}" target="_blank"> <i class="ft-external-link"></i></a>
                        </span>
                        <span *ngIf="!course?.title">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="width_td_10rem">Total Fees:</td>
                      <td>
                        <span>{{course?.total_fees}}</span>
                        <span *ngIf="!course?.total_fees">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="width_td_10rem">About:</td>
                      <td>
                        <span>{{course?.about}}</span>
                        <span *ngIf="!course?.about">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td class="width_td_10rem">Announcements:</td>
                      <td>
                        <span>{{course?.announcements}}</span>
                        <span *ngIf="!course?.announcements">Data Not Found</span>
                      </td>
                    </tr>
                  </tbody>
                
                 </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-12"  *ngIf="role !=='admin' && role !=='employee'">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <h4 class="card-title">
                  <span>Batch </span>
                 </h4>
                 <div class="mt-3" *ngFor="let batch of batches">
                  <tbody >
                  
                    <tr>
                      <td>Name:</td>
                      <td>
                        <span style="font-size: bold;">{{batch?.name}} 
                          <!-- <a href="{{courseUrl}}" target="_blank"> <i class="ft-external-link"></i></a> -->
                        </span>
                        <span *ngIf="!batch?.name">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Start Time:</td>
                      <td>
                        <span style="font-size: bold;">{{batch?.start_time}} AM
                        </span>
                        <span *ngIf="!batch?.start_time">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td>End Time:</td>
                      <td>
                        <span style="font-size: bold;">{{batch?.end_time}} PM 
                        </span>
                        <span *ngIf="!batch?.end_time">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Description:</td>
                      <td>
                        <span style="font-size: bold;">{{batch?.description}} 
                        </span>
                        <span *ngIf="!batch?.description">Data Not Found</span>
                      </td>
                    </tr>
                  </tbody>
                
                 </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Info ends -->
      </div>
    </div>
    <div class="col-12">
      <div #dynamicContainer></div>
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="col-12">
              <h5 class="mb-2 text-bold-500">
                <i></i> Transaction Info
              </h5>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th>Net Fee</th>
                      <th>Total Paid</th>
                      <th>Pending Fee</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let transaction of transactionData">
                      <td>
                        <span>{{ transaction.net_amount |  currency:'INR':'symbol' }}</span>
                      </td>
                      <td>
                        <span>{{ transaction.total_paid |  currency:'INR':'symbol' }}</span>
                      </td>
    
                      <td>
                        <span
                          class="badge bg-light-danger">{{ transaction?.pendingAmount |  currency:'INR':'symbol' }}</span>
                      </td>
                      <td>
                        <span *ngIf="transaction?.payment_status =='due'"
                          class="badge bg-light-warn">{{ transaction?.payment_status }}</span>
                        <span *ngIf="transaction?.payment_status =='received'"
                          class="badge bg-light-success">{{ transaction?.payment_status }}</span>
    
                      </td>
    
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="!transactionData">Data Not Found</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    

    <div class="col-12">
      <!-- Query Section Starts -->
        <div class="row mb-2 mt-4">
            <div class="col-12 text-center">
                <h3 class="faq-subtitle my-3">Contact Us for further inquiries</h3>
                <p class="p-2 text-muted font-medium-1 mb-4">If you need any clarification or assistance, you can dirctly contact us. We will answer to you shortly!</p>
            </div>
        </div>
        <div class="row d-flex justify-content-center mb-5">
            <div class="col-sm-12 col-md-4 text-center border rounded p-3 mr-md-3 m-2">
                <div class="mb-2 d-inline-block">
                    <i class="ft-phone-call primary font-large-1 cursor-pointer"></i>
                </div>
                <h5>+ (91) 80904-29042</h5>
                <p class="text-muted font-medium-1 m-0">We are always happy to help!</p>
            </div>
            <div class="col-sm-12 col-md-4 text-center border color-gray-faq rounded p-3 m-2">
                <div class="mb-2 d-inline-block">
                    <i class="ft-mail primary font-large-1 cursor-pointer"></i>
                </div>
                <h5><a href="mailto:meandersoftware@gmail.com">hi@meander.software</a></h5>
                <p class="text-muted font-medium-1 m-0">Best way to get answer faster!</p>
            </div>
        </div>
      <!-- Query Section Starts -->
    </div>
  </div>
</section>
